import { useEffect,useState } from 'react'
import { Department } from '../../../types/dataModel';
import {API} from '../../../common/Constants'
import useFetch from '../../../hooks/useFetch';
import PreLoader from '../../../core/common/preLoader';
import { getAPIHeaders, isNotEmpty } from '../../../common/Utils';
import { Link } from 'react-router-dom'

interface Props {
  onSuccess: ()=> void
}


const AddDepartment = ({onSuccess}:Props) => {
  const [department, setDepartment] = useState<Department>()
  const [errorMessage, setErrorMessage] = useState<string | undefined>("");
  const {isLoading, error, data, status, callFetch } = useFetch();
  const [showMsgBox, setShowMsgBox] = useState<boolean>(false)

    useEffect(() => {
          if(data && status && status < 299){
              reset();
              setShowMsgBox(true)
              onSuccess()
          }
     }, [status]);

    useEffect(() => {
        if(error){
          if(error.response?.data){
            setErrorMessage(error.response?.data)
          } else{
            setErrorMessage('Something went wrong please try again later.')
          }
        }
    }, [error]);

  const handleSubmit = (event:any) => {
      event.preventDefault()
      if(!isNotEmpty(department?.name)){
        setErrorMessage("Please provide department name")
      } else if(!isNotEmpty(department?.description)){
        setErrorMessage("Please provide description")
      } else {
        setErrorMessage("")
        callFetch(API.DEPARTMENT,
            'POST',
            getAPIHeaders(),
            null,
            {
                ...department
            }
        );
      }
    }

    const reset = () => {
      setDepartment({
        name:"",
        description:""
      })
      setErrorMessage("")
      setShowMsgBox(false)
    }

    const renderDepartmentForm = () => {
      return (
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Add Department</h4>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={reset}
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <form>
            <div className="modal-body pb-0">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Department Name <span className="text-danger"> *</span></label>
                    <input type="text" className="form-control" 
                    value={department?.name}
                    onChange={(e)=>{
                      setDepartment({
                        ...department,
                        name: e.target.value
                      })
                    }}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Description <span className="text-danger"> *</span></label>
                    <input type="text" className="form-control"
                        value={department?.description}
                        onChange={(e)=>{
                            setDepartment({
                                ...department,
                                description: e.target.value
                            })
                        }} />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer" style={{ 
                justifyContent: "space-between",
                flexDirection:'row'}}>
                <div style={{maxWidth:"50%"}}>
                        { errorMessage  ?
                          <>
                            <i className="ti ti-alert-triangle text-danger" />  
                            <span className='text-danger'> {errorMessage} </span> 
                          </> 
                          : <></>
                        }
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                    onClick={reset}
                  >
                    Cancel
                  </button>
                  <button type="button"
                    className="btn btn-primary"
                    onClick={handleSubmit}>
                    Add Department
                  </button>
              </div>
            </div>
          </form>
        </div>
      )
    }

    const renderMsgBox = () => {
      return (          
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body text-center">
              <span className="avatar avatar-xl bg-transparent-success text-success mb-3">
                  <i className="ti ti-thumb-up fs-36" />
              </span>
              <h4 className="mb-1">Add Department Successfull</h4>
              <p className="mb-3">
                  Department is added successfully.
              </p>
              <div className="d-flex justify-content-center">
                  <Link to="#" 
                      data-bs-dismiss="modal" 
                      className="btn btn-success"
                      onClick={()=>{
                        setTimeout(() => {
                          setShowMsgBox(false);
                        }, 1000);
                        }}>
                      Close
                  </Link>
              </div>
          </div>
      </div>
    </div>)
    }

    return (
      <div className="modal-dialog modal-dialog-centered modal-md"
      data-bs-backdrop="static"
      data-bs-keyboard="false">
        <PreLoader showLoader={isLoading} />
        {showMsgBox ? renderMsgBox() : renderDepartmentForm()}
      </div>
    )
}

export default  AddDepartment